// require( './object/assign' );
// require( './object/iterable' );
// require( './array/find' );
require( './array/limit' );
require( './array/offset' );
require( './array/chunks' );
require( './number' );

if( !Array.prototype.max ) Array.prototype.max = function() {
  return Math.max.apply(null, this);
};

if( !Array.prototype.min ) Array.prototype.min = function() {
  return Math.min.apply(null, this);
};

if( !String.prototype.trim )
{
    (function() {
        // Make sure we trim BOM and NBSP
        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        String.prototype.trim = function() {
            return this.replace(rtrim, '');
        };
    })();
}

module.exports = {};